import { useEffect, useState } from "react";
import "./transfer.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Button, Table, Accordion, Dropdown } from "react-bootstrap";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import {
  addData,
  fetchAllData,
  getAllData,
  updateUser,
} from "../../Utility/API";
import moment from "moment-timezone";
import { endPoints, paymentEndpoints } from "../../constant/Environment";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { Actions } from "../../redux/Actions/Actions";
const Transfer = () => {
  const User = useSelector((state) => state?.auth?.user?.data);
  const dispatch = useDispatch();
  const [adminBal, setAdminBal] = useState(User?.account?.balance || "");
  const [isLoading, setIsLoadinig] = useState(false);
  const [admin, setAdmin] = useState({});
  const [riskmng, setRiskMng] = useState({});
  const [allusers, setAllusers] = useState([]);
  const [showall, setShowAll] = useState(false);
  const [showother, setShowOther] = useState(false);
  const [selected, setSelected] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);
  const [amount, setAmount] = useState("");
  const [amountEnter, setAmountEnter] = useState("");
  const [type, setType] = useState("Deposit");
  const [checked, setChecked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [selectAmountInput, setSelectAmountInput] = useState('')

  const [searchid, setSearchid] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    getAll();
  }, []);
  const getAll = () => {
    let url1 = endPoints.api.GET_ADMIN;
    let url2 = endPoints.api.GET_RISKMANAGER;
    let url3 = endPoints.api.GET_ALL_USERS;
    setIsLoadinig(true);
    const Promise1 = getAllData(url1);
    const Promise2 = getAllData(url2);
    const Promise3 = getAllData(url3);
    Promise.all([Promise1, Promise2, Promise3])
      .then((response) => {
        setIsLoadinig(false);
        let result1 = response[0]?.data;
        setAdmin(result1);
        let result2 = response[1]?.data;
        setRiskMng(result2);
        setSelected(result2);
        let result3 = response[2]?.data;
        setAllusers(result3);
      })
      .catch((err) => {
        setIsLoadinig(false);
        console.log(err);
      });
  };
  const handleChange = (event) => {

    let value = event.target.value.replace(/[^0-9.]/g, '')
    setAmountEnter(value);
  };
  const WithdrawDeposit = () => {
    // const walletUserId = selected?.account?.fwUserId;
    // let activeAccount = walletUserId === null ? true : false;
    // if (activeAccount) {
    //   ErrorToast(
    //     "Please set up your wallet in order to use this functionality"
    //   );
    //   return;
    // }

    if (amountEnter !== "" && type !== "") {
      let data1 = {
        userId: selected?.idUser,
        walletUserId: selected?.account?.fwUserId, // '8c7cd185-1d6e-412e-644e-08da3feb0940',//
        transferType: type,
        amount: amountEnter,
      };
      // console.log("selected", selected);
      // console.log("udsr", User);
      let data = {
        description: description, //not coming from API
        type: type === "Deposit" ? 1 : 2,
        id_user: selected?.idUser,
        amount: amountEnter,
        referred_user: selected?.idUser,
        id_session: User?.sessionId,
        id_account: User?.idUser,
        transaction_id: "string",
        external_id: "string",
        pin: 0, //not coming from API
        balanceType : selectAmountInput == 'Bouns' ? "bouns" : 'balance' , 
        //"balance"  selectAmountInput == 'Bouns' ? "bouns" : selectAmountInput == 'Amount' ? 'balance' :'balance' , 
      };
      let url = endPoints.api.deposit;
      let url1 = endPoints.api.withdraw;
      setIsLoadinig(true);
      addData(type === "Deposit" ? url : url1, data)
        .then((response) => {
          setIsLoadinig(false);

          UpdateAdmin();
          if (response.data.status === "success") {
            type === "Deposit"
              ? SuccesToast("Amount Deposit Succesfully")
              : SuccesToast("Amount Withdrawn Succesfully");
            setAmountEnter("");
            setDescription("")
            //  setType("");
            // setChecked(false)
            onUserClick(selected);
          } else {
            ErrorToast(response?.data.message);
          }
        })
        .catch((err) => {
          setIsLoadinig(false);
          console.log(err);
        });
    } else {
      amount === ""
        ? ErrorToast("Enter Amount")
        : ErrorToast("Select Deposit Type");
    }
  };
  const onUserClick = (item) => {
    let url = `${endPoints.api.GET_BY_USERID}/${item.idUser}`;
    setIsLoadinig(true);
    getAllData(url)
      .then((response) => {
        setIsLoadinig(false);
        if (response.status === "success") {
          setSelected(response?.data);
          setAmount(response?.data?.account?.balance);
        }
      })
      .catch((err) => {
        setIsLoadinig(false);
        console.log(err);
      });
    setIsAdmin(false);
  };
  const onAdminClick = () => {
    setIsAdmin(true);
    setSelected(admin);
  };
  const UpdateAdmin = () => {
    let url = `${endPoints.api.GET_BY_USERID}/${User?.idUser}`;
    getAllData(url)
      .then((response) => {
        if (response.status === "success") {
          setAdminBal(response.data?.account?.balance);
          // dispatch({
          //   type: Actions.LOGIN,
          //   data: { user: response },
          // });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const filteredData = allusers.filter((item2) => {
    const login = item2.login.toLowerCase().includes(searchQuery.toLowerCase());
    const idUser = item2.idUser.toString().includes(searchid);
    return login && idUser;
  });

  const filterList = (e) => {
    setSearchQuery(e.target.value);
  };

  const filterList2 = (e) => {
    setSearchid(e.target.value);
  };

//console.log('type',type)
  return (
    <div className="main">
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}
      <div class="manager_central">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3">
              <div class="left_manager full_manager_div">
                <div class="box_effect">
                  <h3>USER DATA</h3>
                </div>
                <div class="sub_manager">
                  <h3>Personal Information</h3>
                </div>

                {!isAdmin && (
                  <div class="manager_table">
                    <table class="table table-hover">
                      <tbody>
                        <tr>
                          <td>Name: </td>
                          <td>{selected?.name}</td>
                        </tr>
                        <tr>
                          <td>Surname: </td>
                          <td>{selected?.surname}</td>
                        </tr>
                        <tr>
                          <td>Gender: </td>
                          <td>{selected?.sex}</td>
                          {/* <input type="text" name="" /> */}
                        </tr>
                        <tr>
                          <td>Language: </td>
                          <td>{selected?.language} </td>
                        </tr>
                        <tr>
                          <td>Date of birth: </td>
                          <td>{selected?.birthDate} </td>
                        </tr>
                        <tr>
                          <td>Email: </td>
                          <td>{selected?.email}</td>
                        </tr>
                        {showother && (
                          <tr>
                            <td>Type of document: </td>
                            <td>{selected?.documentTypeId}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Document number: </td>
                            <td>{selected?.documentId}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Phone: </td>
                            <td>{selected?.phone}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Mobile: </td>
                            <td>{selected?.mobile}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Fax: </td>
                            <td>{selected?.fax}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Nation: </td>
                            <td>{selected?.nation}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Country/State: </td>
                            <td>{selected?.country}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Town: </td>
                            <td>{selected?.town}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Address: </td>
                            <td>{selected?.address}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Time zone: </td>
                            <td>{selected?.timeZone}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {!showother && (
                      <div class="text-center mb-5">
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          onClick={() => setShowOther(true)}
                        >
                          Other
                        </button>
                      </div>
                    )}
                  </div>
                )}
                {isAdmin && (
                  <div class="manager_table">
                    <table class="table table-hover">
                      <tbody>
                        <tr>
                          <td>Name: </td>
                          <input type="text" value={selected?.name} />
                        </tr>
                        <tr>
                          <td>Surname: </td>
                          <input type="text" value={selected?.surname} />
                        </tr>
                        <tr>
                          <td>Gender: </td>
                          <div>
                            <select value={selected?.sex}>
                              <option value="M">Male</option>
                              <option value="F">Female</option>
                            </select>
                          </div>
                        </tr>
                        <tr>
                          <td>Language: </td>
                          <div>
                            <select value={selected?.language}>
                              <option value="en_GB">English</option>
                            </select>
                          </div>
                        </tr>
                        <tr>
                          <td>Date of birth: </td>
                          <input
                            type="date"
                            id="birthday"
                            name="birthday"
                            value={selected?.birthDate}
                          ></input>
                        </tr>
                        <tr>
                          <td>National Insurance number: </td>
                          <input type="text" />
                        </tr>
                        <tr>
                          <td>Nation: </td>
                          <input type="text" value={selected?.nation} />
                        </tr>
                        <tr>
                          <td>Country/State: </td>
                          <input type="text" value={selected?.country} />
                        </tr>
                        <tr>
                          <td>Town: </td>
                          <input type="text" value={selected?.town} />
                        </tr>
                        <tr>
                          <td>Email: </td>
                          <input type="text" value={selected?.email} />
                        </tr>
                        <tr>
                          <td>Type of document: </td>
                          <div>
                            <select value={selected?.documentTypeId}>
                              <option value="1">Id Card</option>
                            </select>
                          </div>
                        </tr>
                        <tr>
                          <td>Document number: </td>
                          <input type="text" value={selected?.documentId} />
                        </tr>
                        <tr>
                          <td>Phone: </td>
                          <input type="text" value={selected?.phone} />
                        </tr>
                        <tr>
                          <td>Mobile: </td>
                          <input type="text" value={selected?.mobile} />
                        </tr>
                        <tr>
                          <td>Fax: </td>
                          <input type="text" value={selected?.fax} />
                        </tr>
                        <tr>
                          <td>Time zone: </td>
                          <td>{selected?.timeZone}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

            <div class="col-md-6">
              <div class="left_manager full_manager_div">
                <div class="box_effect">
                  <h3>USER DETAIL</h3>
                </div>

                <div class="mt-3">
                  <div class="row">
                    <div class="col-md-6">
                      <input
                        class="form-control mt-3"
                        type="text"
                        value={
                          selected?.type == -1
                            ? "VISITOR:VISITOR"
                            : selected?.type == 0
                            ? "FINANCIAL:FINANCIAL"
                            : selected?.type == 1
                            ? "TRADER:TRADER"
                            : selected?.type == 2
                            ? "USER:USER"
                            : selected?.type == 3
                            ? "OPERATOR:OPERATOR"
                            : selected?.type == 4
                            ? "AGENCY:AGENCY"
                            : ""
                        }
                        aria-label="Disabled input example"
                        disabled
                        readonly
                      />
                    </div>
                    <div class="col-md-6">
                      {/* <input
                        class="form-control mt-3"
                        type="text"
                        value={`Balance: $ ${amount}`}
                        aria-label="Disabled input example"
                        disabled
                        readonly
                      /> */}
                        <span  class="form-control mt-3" style={{backgroundColor: selectAmountInput == 'Amount' ? '#e9ecef' : 'white',
                        opacity: '1',cursor:'pointer'}} onClick=
                        { ()=>{
                          setSelectAmountInput('Amount')
                        }

                        }>
                        {`Balance: $  ${selected?.account?.balance || ''}`}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                
                    </div>
                    <div class="col-md-6">
                      <span  class="form-control mt-3" style={{backgroundColor: selectAmountInput == 'Bouns' ? '#e9ecef' : 'white',
                      opacity: '1',cursor:'pointer'}} onClick=
                      { ()=>{
                        setSelectAmountInput('Bouns')
                      }

                      }>
                      {`Bouns: $ ${selected?.account?.bonusBalance || ''}`}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                
                    </div>
                    <div class="col-md-6">
                      <span  class="form-control mt-3" style={{backgroundColor: '#e9ecef',opacity: '1'}}>
                      {`Total Balance: $ ${selected?.account?.totalBalance || ''}`}
                      </span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <input
                        class="form-control mt-3"
                        type="text"
                        value="Created on:"
                        aria-label="Disabled input example"
                        disabled
                        readonly
                      />
                    </div>
                    <div class="col-md-6">
                      <input
                        class="form-control mt-3"
                        type="text"
                        value={moment(selected?.insertionTime).format(
                          "MMMM d, YYYY"
                        )}
                        aria-label="Disabled input example"
                        disabled
                        readonly
                      />
                    </div>
                  </div>
                </div>

                <div class="sub_manager mt-4">
                  <h3>Transfer</h3>
                </div>
                <div class="manager_table">
                  <table class="table table-hover">
                    <tbody>
                      <tr>
                        <td>Amount: </td>
                        <td>
                          ${" "}
                          <input
                            type="text"
                            name=""
                            value={amountEnter}
                            onChange={handleChange}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Type </td>
                        <td>
                          <div class="form-check form-check-inline">
                            {/* <input
                              class="form-check-input"
                              type="checkbox"
                              id="inlineCheckbox1"
                 

                              // checked={
                              //   type === "Deposit" ? checked : !checked
                              // }
                              // onChange={(e) => {
                              //   setChecked(e.target.checked);
                              //   setType("Deposit");
                              // }}
                            /> */}
                             <div key={`inline-radio`} className="mb-3">
          <Form.Check
            inline
            label="Deposit"
            name="group1"
            type={'radio'}
            id={`inline-radio-1`}
          
               onChange={(e) => {
                                setChecked(e.target.checked);
                                setType("Deposit");
                              }}
            
          />
             <Form.Check
            inline
            label="WithDraw"
            name="group1"
            type={'radio'}
            id={`inline-radio-1`}
            onChange={(e) => {
              setChecked(e.target.checked);
              setType("WithDraw");
            }}
          />
          </div>
                            {/* <label
                              class="form-check-label"
                              for="inlineCheckbox1"
                            >
                              Deposit
                            </label> */}
                          </div>
                          {/* <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="inlineCheckbox2"
                              //value={type}
                              checked={type === "Deposit" ? checked : !checked}
                              onChange={(e) => {
                                setChecked(e.target.checked);
                                setType("Deposit");
                              }}
                              // onClick={() => type === '' ? setType('Withdrawal') : null}
                            />
                            <label
                              class="form-check-label"
                              for="inlineCheckbox2"
                            >
                              Withdrawal
                            </label>
                          </div> */}
                        </td>
                      </tr>
                      <tr>
                        <td>Description: </td>
                        <td>
                          <input
                            type="text"
                            name="description"
                            value={description}
                            onChange={(event) => {
                              setDescription(event.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      {/* <tr>
                        <td>Pin: </td>
                        <td>
                          <input type="text" name="" />{" "}
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                  <div class="text-center mb-5">
                    <button
                      type="button"
                      disabled={selected?.idUser ? false : true}
                      class="btn btn-outline-secondary"
                      onClick={WithdrawDeposit}
                    >
                      Perform
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="left_manager full_manager_div">
                {/* <div class="box_effect">
                  <h3>Admin  </h3>
                </div>
                <table class="table table-hover">
                  <tbody>
                    <tr>
                      <td>
                        <label
                          style={{ cursor: "pointer" }}
                          onClick={() => onAdminClick()}
                        >
                          Balance : $ {adminBal}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label
                          style={{ cursor: "pointer",fontWeight:'bold'}}
                          onClick={() => onAdminClick()}
                        >
                      
                          {riskmng?.login}
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table> */}
                <div class="box_effect">
                  <h3>All USERS </h3>
                </div>
                
                {/* <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Search"
                  onChange={(e) => {
                    filterList(e);
                  }}
                  style={{ marginBottom: "20px" }}
                /> */}

                <div class="manager_table2">
                  <table class="table table-hover">
                    <tbody>
                      <tr>
                        <td style={{ fontWeight: "bold" }}>{"USER "}
                        <input
                        type="text"
                        className="form-control form-control-md"
                        placeholder="Search"
                        onChange={(e) => {
                        filterList(e);
                        }}
                        style={{ marginBottom: "3px",marginTop: "3px" }}
                        />
                        </td>
                        <td 
                        style={{ fontWeight: "bold" }}>{"Id "}
                        <input
                        type="text"
                        className="form-control form-control-md"
                        placeholder="Search"
                        onChange={(e) => {
                        filterList2(e);
                        }}
                        style={{ marginBottom: "3px",marginTop: "3px" }}
                        />
                        </td>
                        <td style={{ fontWeight: "bold" }}>{" NAME "}</td>
                      </tr>

                      {filteredData
                        .map((item, index) => {
                          //  allusers?.map((item) => {
                          if (
                            item.idUser != admin?.idUser &&
                            item.idUser != riskmng?.idUser
                          ) {
                            return (
                              <tr onClick={() => onUserClick(item)}>
                                <td>
                                  <label
                                    style={{ cursor: "pointer" }}
                                    onClick={() => onUserClick(item)}
                                  >
                                    {" "}
                                    {item.login}
                                  </label>
                                </td>
                                
                                <td>
                                  <label
                                    style={{ cursor: "pointer" }}
                                    onClick={() => onUserClick(item)}
                                  >
                                    {" "}
                                    {item.idUser}
                                  </label>
                                </td>

                                <td>
                                  <label
                                    style={{ cursor: "pointer" }}
                                    onClick={() => onUserClick(item)}
                                  >
                                    {item.name}
                                  </label>
                                </td>
                              </tr>
                            );
                          }
                        })}
                    </tbody>
                  </table>
                </div>

                {/* <div class="manager_div_collapse">
                  <div class="accordion accordion-flush" id="accordionFlushExample">
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header> Explore subnet</Accordion.Header>
                        <Accordion.Body>
                          <Form>

                            <div className="mb-3">
                              <Form.Check

                                label="show blocked users"
                                name="group1"
                                type='radio'

                              />
                              <Form.Check

                                label="hide blocked users"
                                name="group1"
                                type='radio'

                              />
                            </div>
                            <Form.Text id="balance"   >
                              Balance : $ {adminBal} <br></br>
                            </Form.Text>
                            <Form.Text id="admin" onClick={() => onAdminClick()} >
                              {admin?.login} <br></br>
                            </Form.Text>
                            <Form.Text id="risk"   >
                              {riskmng?.login} <br></br>
                            </Form.Text>
                            <div className='bg-collapse'>
                              <Form.Text id="balance"   >
                                {
                                  showall ? <FiMinusCircle onClick={() => setShowAll(!showall)}></FiMinusCircle> :
                                    <FiPlusCircle onClick={() => setShowAll(!showall)} />
                                }
                                &nbsp; system operator <br></br>
                                <div className='overflow-height'>
                                  {showall && allusers?.map((item) => {

                                    if (item.idUser != admin?.idUser && item.idUser != riskmng?.idUser) {
                                      return (

                                        <div style={{ display: 'flex' }}>
                                          <label style={{ cursor: 'pointer' }} onClick={() => onUserClick(item)}> {item.login} </label>
                                        </div>

                                      )
                                    }

                                  })}
                                </div>
                              </Form.Text>
                            </div>
                          </Form>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="flush-headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                          Partners
                        </button>
                      </h2>
                      <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo"
                        data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Placeholder content for this accordion, which is intended to demonstrate
                          the <code>.accordion-flush</code> class. This is the second item's accordion body. Let's imagine
                          this being filled with some actual content.</div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="flush-headingThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                          Incremental Search
                        </button>
                      </h2>
                      <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree"
                        data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Placeholder content for this accordion, which is intended to demonstrate
                          the <code>.accordion-flush</code> class. This is the third item's accordion body. Nothing more
                          exciting happening here in terms of content, but just filling up the space to make it look, at
                          least at first glance, a bit more representative of how this would look in a real-world
                          application.</div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transfer;
